import React from 'react'
import { useMCProExperiment } from '../../../hooks/useMCProExperiment'
import { StackedTiles } from '../../StackedTiles'
import { DesktopMatrix } from './DesktopMatrix'
import { ProposalMatrix } from './fullFunnel'

export const Matrix = () => {
  const { variant2Layout } = useMCProExperiment()

  return (
    <>
      <div className='d-lg-none'>
        <StackedTiles />
      </div>
      <div className='d-none d-lg-block mc-mb-9'>
        {variant2Layout === 'current' ? (
          <DesktopMatrix />
        ) : (
          <ProposalMatrix layout={variant2Layout} />
        )}
      </div>
    </>
  )
}
